module.exports = __webpack_public_path__ + "img/tmenu4.e63189a7.png";